interface RedirectProps {
    isBlank: boolean;
    url: string;
}

const analyticsTrack = (
    event_name: string,
    category?: string,
    redirect?: RedirectProps,
) => {
    const callback = () => {
        if (redirect && redirect.url) {
            if (redirect.isBlank) {
                window.open(redirect.url, '_blank');
            } else {
                window.location.href = redirect.url;
            }
        }
    };

    if (window.analytics) {
        window.analytics.track(
            event_name,
            {
                SiteCategory: category || 'Application',
                category: category || 'Application',
            },
            callback,
        );
    } else {
        callback();
    }
};

export default analyticsTrack;
